import { SPI, ViewWidget, DslNodeWidget, useMatched, Widget, Subscription, subscribeRoute } from '@kunlun/dependencies';
import Comp from './MobileMall.vue';

@SPI.ClassFactory(
  ViewWidget.Token({
    widget: 'MobileMall'
  })
)
export default class MobileMallWidget extends DslNodeWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  private routeSubscription!: Subscription;

  @Widget.Reactive()
  private visible = false;

  protected async mounted() {
    this.routeSubscription = subscribeRoute(
      (url) => {
        const { matched } = useMatched();
        const { segmentParams } = matched;

        // 经销工作台
        if (segmentParams?.page?.module === 'deliAriesCoreMerchant') {
          this.visible = true;
        } else {
          this.visible = false;
        }
      },
      {
        distinct: true
      }
    );
  }

  protected $$unmounted(): void {
    super.$$unmounted();
    this.routeSubscription?.unsubscribe();
  }
}
